var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472,120h-48V8c0-4.424-3.584-8-8-8H8C3.584,0,0,3.576,0,8v352c0,4.424,3.584,8,8,8h72v104c0,4.424,3.584,8,8,8h352    c22.056,0,40-17.944,40-40V128C480,123.576,476.416,120,472,120z M16,16h392v48H16V16z M80,128v224H16V80h392v40H88    C83.584,120,80,123.576,80,128z M464,440c0,13.232-10.768,24-24,24H96V184h368V440z M464,168H96v-32h368V168z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#CD1B1B",
    fill: "#444444"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176,200c-35.288,0-64,28.712-64,64c0,35.288,28.712,64,64,64c4.416,0,8-3.576,8-8v-48h48c4.416,0,8-3.576,8-8    C240,228.712,211.288,200,176,200z M176,256c-4.416,0-8,3.576-8,8v47.336c-22.672-3.824-40-23.592-40-47.336    c0-26.472,21.528-48,48-48c23.744,0,43.512,17.328,47.336,40H176z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#CD1B1B",
    fill: "#444444"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,288h-48c-4.416,0-8,3.576-8,8v48c0,4.424,3.584,8,8,8c30.88,0,56-25.128,56-56C264,291.576,260.416,288,256,288z     M216,335.192V304h31.192C244.008,319.648,231.648,332.008,216,335.192z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#CD1B1B",
    fill: "#444444"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 432,
    width: 328,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#CD1B1B",
    fill: "#444444"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M425.248,235.712l-51.36,80.712L348.8,297.6c-1.936-1.464-4.432-1.936-6.784-1.352c-2.352,0.6-4.304,2.232-5.304,4.44    l-35.744,78.64l-31.976-25.576c-3.392-2.72-8.352-2.2-11.144,1.128l-35.616,42.744l-34.128-20.48    c-2.352-1.408-5.248-1.512-7.696-0.296l-48,24l7.16,14.312l44.072-22.04l36.232,21.744c1.296,0.768,2.712,1.136,4.128,1.136    c2.312,0,4.584-1,6.152-2.872l34.984-41.976l33.88,27.104c1.928,1.528,4.472,2.12,6.856,1.528c2.4-0.576,4.4-2.224,5.424-4.472    l35.88-78.936L371.2,334.4c1.776,1.336,4.032,1.896,6.232,1.472c2.192-0.4,4.12-1.696,5.32-3.568l56-88L425.248,235.712z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#CD1B1B",
    fill: "#444444"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 208,
    width: 56,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#CD1B1B",
    fill: "#444444"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 208,
    width: 16,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#CD1B1B",
    fill: "#444444"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 208,
    width: 16,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#CD1B1B",
    fill: "#444444"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 240,
    width: 16,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#CD1B1B",
    fill: "#444444"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 240,
    width: 16,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#CD1B1B",
    fill: "#444444"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 240,
    width: 40,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#CD1B1B",
    fill: "#444444"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 16,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#CD1B1B",
    fill: "#444444"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 32,
    width: 16,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#CD1B1B",
    fill: "#444444"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 32,
    width: 16,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#CD1B1B",
    fill: "#444444"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.aec4d713b472529e23ae9d810f413ebe.svg";
export { ForwardRef as ReactComponent };